<template>
  <div>
    <template v-if="useLocalCanvas">
      <TenantReportHeader></TenantReportHeader>
      <h2>Pro Risk Canvas</h2>
    </template>
    <div v-if="loading" v-loading="loading" element-loading-spinner="atom-audit-loader" :class="isPrintable ? 'printable-min-height' : 'dashboard-min-height'"></div>
    <div>
      <template v-if="projectCanvasList.length > 0">
        <ProRiskCanvas class="canvas-wrapper" v-for="(canvas, index) in projectCanvasList" :options="calcOptions" :isDashboard="true" :key="index" :propCanvas="canvas" :isPrintable="isPrintable" />
      </template>
      <div v-if="!loading && projectCanvasList.length === 0 && !isPrintable" class="no-data-message" style="min-height: 200px;">
        <center>No Canvases Associated with this Project, use the Pro Risk Canvas tab to add a Canvas</center>
      </div>
    </div>
    <span class="watermark">Powered by Atom Audit</span>
  </div>
</template>

<script>
  import { mapActions, mapState, mapMutations } from 'vuex'
  import ProRiskCanvas from '@/views/riskAnalysis/ProRiskCanvas.vue'
  import TenantReportHeader from '@/views/reports/printable/TenantReportHeader.vue'
  export default {
    name: 'CanvasWrapper',
    components: {
      ProRiskCanvas,
      TenantReportHeader
    },
    props: {
      projectId: {
        type: Number,
        required: false
      },
      isPrintable: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    data() {
      return {
        useLocalCanvas: false,
        loading: false
      }
    },
    methods: {
      ...mapActions('proReviews/canvas/', ['GET_CANVAS_BY_PROJECT_ID']),
      ...mapMutations('proReviews/canvas/', ['SET_PROJECT_CANVAS_LIST'])
    },
    async created() {
      this.useLocalCanvas = this.$route.query.useLocalCanvas === 'true'
      if (this.useLocalCanvas) {
        const localCanvasList = window.localStorage.getItem('canvasList')
        this.SET_PROJECT_CANVAS_LIST([JSON.parse(localCanvasList)])
        return
      }

      if (this.projectId) {
        this.loading = true
        try {
          await this.GET_CANVAS_BY_PROJECT_ID(this.projectId)
        } catch (error) {
          console.error(error)
          this.$message.error('Error loading canvas list: ' + error.message)
        } finally {
          this.loading = false
        }
      }
    },
    computed: {
      calcOptions() {
        const options = []
        if (this.useLocalCanvas) {
          options.push('download')
        }
        return options
      },
      ...mapState('proReviews/canvas/', ['projectCanvasList'])
    }
  }
</script>

<style scoped>
  .canvas-wrapper:not(:first-child) {
    margin-top: 30px;
  }

  .dashboard-min-height {
    min-height: 200px;
  }

  .printable-min-height {
    min-height: 0px;
  }

  .watermark {
    display: none;
  }

  >>> .frequency-table {
    box-shadow: none !important;
  }

  @media print {
    .watermark {
      display: block;
      font-size: 8px;
      bottom: 0;
      position: fixed;
      right: 10px;
      font-style: italic;
    }

    .canvas-wrapper:not(:first-child) {
      break-before: page;
      page-break-before: always;
    }
  }
</style>
